
import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* 品牌區域 */}
          <div className="col-span-1 md:col-span-2">
            <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              命理大師
            </h2>
            <p className="text-gray-300 mb-6 leading-relaxed">
              專業提供<strong>塔羅占卜</strong>、<strong>八字算命</strong>、<strong>紫微斗數</strong>、<strong>星座運勢</strong>等命理諮詢服務。
              我們的資深命理師團隊擁有豐富經驗，致力於為每位客戶提供準確的運勢分析和人生指導。
            </p>
            
            {/* 服務特色 */}
            <div className="grid grid-cols-2 gap-4 mb-6">
              <div className="flex items-center text-sm text-gray-300">
                <i className="ri-check-line text-green-400 mr-2"></i>
                <span>24小時線上諮詢</span>
              </div>
              <div className="flex items-center text-sm text-gray-300">
                <i className="ri-check-line text-green-400 mr-2"></i>
                <span>專業認證命理師</span>
              </div>
              <div className="flex items-center text-sm text-gray-300">
                <i className="ri-check-line text-green-400 mr-2"></i>
                <span>隱私保護保證</span>
              </div>
              <div className="flex items-center text-sm text-gray-300">
                <i className="ri-check-line text-green-400 mr-2"></i>
                <span>滿意度保證</span>
              </div>
            </div>
            
            {/* 社交媒體 */}
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-purple-600 rounded-full flex items-center justify-center hover:bg-purple-700 transition-colors cursor-pointer" aria-label="Facebook粉絲專頁">
                <i className="ri-facebook-fill"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-purple-600 rounded-full flex items-center justify-center hover:bg-purple-700 transition-colors cursor-pointer" aria-label="Instagram官方帳號">
                <i className="ri-instagram-line"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-purple-600 rounded-full flex items-center justify-center hover:bg-purple-700 transition-colors cursor-pointer" aria-label="LINE官方帳號">
                <i className="ri-line-fill"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-purple-600 rounded-full flex items-center justify-center hover:bg-purple-700 transition-colors cursor-pointer" aria-label="YouTube頻道">
                <i className="ri-youtube-fill"></i>
              </a>
            </div>
          </div>
          
          {/* 服務項目 */}
          <nav className="col-span-1">
            <h3 className="text-lg font-semibold mb-4">命理服務</h3>
            <ul className="space-y-3">
              <li>
                <a 
                  href="/tarot" 
                  onClick={(e) => { e.preventDefault(); navigate('/tarot'); }}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer flex items-center"
                >
                  <i className="ri-magic-line mr-2 text-yellow-400"></i>
                  塔羅占卜
                </a>
              </li>
              <li>
                <a 
                  href="/bazi" 
                  onClick={(e) => { e.preventDefault(); navigate('/bazi'); }}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer flex items-center"
                >
                  <i className="ri-ancient-gate-line mr-2 text-orange-400"></i>
                  八字算命
                </a>
              </li>
              <li>
                <a 
                  href="/ziwei" 
                  onClick={(e) => { e.preventDefault(); navigate('/ziwei'); }}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer flex items-center"
                >
                  <i className="ri-compass-3-line mr-2 text-purple-400"></i>
                  紫微斗數
                </a>
              </li>
              <li>
                <a 
                  href="/astrology" 
                  onClick={(e) => { e.preventDefault(); navigate('/astrology'); }}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer flex items-center"
                >
                  <i className="ri-star-line mr-2 text-blue-400"></i>
                  星座運勢
                </a>
              </li>
            </ul>
          </nav>
          
          {/* 客戶服務 */}
          <div className="col-span-1">
            <h3 className="text-lg font-semibold mb-4">客戶服務</h3>
            <ul className="space-y-3">
              <li>
                <a 
                  href="/chat" 
                  onClick={(e) => { e.preventDefault(); navigate('/chat'); }}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer flex items-center"
                >
                  <i className="ri-chat-3-line mr-2 text-green-400"></i>
                  線上諮詢
                </a>
              </li>
              <li>
                <a 
                  href="/booking" 
                  onClick={(e) => { e.preventDefault(); navigate('/booking'); }}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer flex items-center"
                >
                  <i className="ri-calendar-line mr-2 text-blue-400"></i>
                  預約服務
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer flex items-center">
                  <i className="ri-question-line mr-2 text-yellow-400"></i>
                  常見問題
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer flex items-center">
                  <i className="ri-customer-service-line mr-2 text-pink-400"></i>
                  客服中心
                </a>
              </li>
            </ul>
            
            {/* 聯絡資訊 */}
            <div className="mt-6">
              <h4 className="font-semibold mb-3 text-purple-300">聯絡我們</h4>
              <div className="space-y-2 text-sm text-gray-300">
                <div className="flex items-center">
                  <i className="ri-mail-line mr-2 text-blue-400"></i>
                  <span>contact@mingli.readdy.ai</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-time-line mr-2 text-yellow-400"></i>
                  <span>24小時線上服務</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* 分隔線 */}
        <div className="border-t border-gray-700 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-sm text-gray-400 mb-4 md:mb-0">
              <p>&copy; 2024 命理大師. 版權所有. 專業命理諮詢服務平台</p>
            </div>
            
            {/* 法律連結 */}
            <div className="flex space-x-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">隱私政策</a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">服務條款</a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">免責聲明</a>
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-400 hover:text-white transition-colors"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
          
          {/* 關鍵詞區域 */}
          <div className="mt-4 text-xs text-gray-500 text-center">
            <p>
              熱門搜尋：塔羅占卜準嗎、八字算命免費、紫微斗數解析、星座運勢2024、愛情運勢占卜、
              事業運勢預測、財運分析、命理師推薦、線上占卜、即時諮詢
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
